import { DSButton } from "@components/design-system/molecules";

import teamGroup from "../../../assets/imgs/team-clinic.png";
import StepWrapper from "../StepWrapper";

export default function TeamSetupChoiceStep({ onCreateTeam }) {
  return (
    <StepWrapper
      title="Teamwork Makes the Dream Work..."
      description="Scribenote pairs well with a veterinary team! You'll be able to invite your fellow staff and share templates, notes, and more!"
      withBackground={false}
    >
      <div className="flex flex-col items-center justify-center">
        <img
          src={teamGroup}
          alt="Team Setup Choice"
          className="h-auto w-[600px]"
        />
        <DSButton
          variant="primary"
          size="lg"
          onClick={onCreateTeam}
          dataTestId="create-team-button"
        >
          Create a Team for my clinic
        </DSButton>
      </div>
    </StepWrapper>
  );
}
